import { Injectable } from '@angular/core';
import { ArticlesActions, OccArticlesService } from '@article/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ArticlesEffects {
  loadList$: Observable<ArticlesActions.ArticlesSearchLoadSuccess | ArticlesActions.ArticlesSearchLoadFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(ArticlesActions.LOAD_ARTICLES_SEARCH),
        map((action: ArticlesActions.ArticlesSearchLoad) => action.payload),
        exhaustMap((params) => {
          return this.occArticlesService.loadList(params).pipe(
            map((response) => new ArticlesActions.ArticlesSearchLoadSuccess(response)),
            catchError((error) => of(new ArticlesActions.ArticlesSearchLoadFail(error))),
          );
        }),
      ),
    );

  loadListByProductCode$: Observable<
    ArticlesActions.ArticlesByProductCodeLoadSuccess | ArticlesActions.ArticlesByProductCodeLoadFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ArticlesActions.LOAD_ARTICLES_BY_PRODUCT_CODE),
      map((action: ArticlesActions.ArticlesByProductCodeLoad) => action.payload),
      switchMap((productCode: string) => {
        return this.occArticlesService.loadListByProductCode(productCode).pipe(
          map((response) => new ArticlesActions.ArticlesByProductCodeLoadSuccess(productCode, response)),
          catchError((error) => of(new ArticlesActions.ArticlesByProductCodeLoadFail(productCode, error))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private occArticlesService: OccArticlesService,
  ) {}
}
